<script setup lang="ts">
const DEPRECATED_MODES = ["acceptance"];
const STAGING_ADMIN_URL = "https://admin.mws-staging.com";

const isDeprecatedEnvironment = DEPRECATED_MODES.includes(
  import.meta.env.VITE_MODE,
);
</script>

<template>
  <div
    v-if="isDeprecatedEnvironment"
    class="bg-yellow-300 px-4 py-2 text-center text-sm font-medium text-yellow-900"
    data-test="environment-deprecation-banner"
  >
    This environment will soon be deprecated and removed. Please start using
    <a
      :href="STAGING_ADMIN_URL"
      class="underline"
    >
      {{ STAGING_ADMIN_URL }}
    </a>
    instead, and contact the platform team about any use case staging doesn't
    support yet.
  </div>
</template>
